import { render, staticRenderFns } from "./host-activity.vue?vue&type=template&id=123c54e2&scoped=true&"
import script from "./host-activity.vue?vue&type=script&lang=js&"
export * from "./host-activity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123c54e2",
  null
  
)

export default component.exports